import { useScopeParams } from "@/hooks/useScopeParams";
import { PageTemplate } from "@/components/Templates/PageTemplate";

export default function Pharmacokinetics({
  singleSubjectId,
}: {
  singleSubjectId?: string;
}) {
  const { id } = useScopeParams();
  const wikiLink = singleSubjectId
    ? "/wiki/guides/exploration-singlesubject-pharmacokinetics"
    : "/wiki/guides/exploration-safety-pharmacokinetics";

  return (
    <PageTemplate
      title="Safety: Pharmacokinetics"
      tooltipText="This table presents each subject's study details and pharmacokinetic (PK) data, including dosing information, sample collection, and any recorded reactions."
      type="pharmacokinetics"
      constants={{
        wikiLink,
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/pharmacokinetics`,
      }}
      subjectId={singleSubjectId}
    />
  );
}
